// fromCode - откуда летим
// toCode - куда летим
// toDate - когда вылетаем
// fromDate - когда летим обратно, from потому что, напрмер, из барселоны
function getFlightFieldValue(fromCode, toCode, toDate, fromDate) {
  const dates = {
    toDate,
  };

  if (fromDate) {
    dates.fromDate = fromDate;
  }

  return {
    from: {
      text: fromCode,
      code: fromCode,
    },
    to: {
      text: toCode,
      code: toCode,
    },
    dates,
  };
}

export function getFlightsFieldValue(route) {
  if (route.directions.length === 0) {
    return [
      {
        from: {},
        to: {},
        dates: {},
      },
    ];
  }

  if (route.isRT) {
    const { fromCode, toCode, date: toDate } = route.directions[0];
    const { date: fromDate } = route.directions[1];

    return [getFlightFieldValue(fromCode, toCode, toDate, fromDate)];
  }

  return route.directions.map(direсtion => {
    const { fromCode, toCode, date } = direсtion;

    return getFlightFieldValue(fromCode, toCode, date);
  });
}
